export default __webpack_public_path__ + "static/media/hotel-white-18dp.93f9ab8a.svg";